import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { PageTabRail } from '@interxfi/app-components/components/page-tab-rail/page-tab-rail';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { IceCaActionsTable } from '../../../../../../../../../../features/vendor/ice/corporate-action/action/ice-ca-actions-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/corporate-action/_action/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorIce,
      label: 'Corporate Actions',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorIce>,
  head: () => getPageHead('ICE Corporate Actions'),
  component: IceCaActionsList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingVendorIce}
    />
  );
}

function IceCaActionsList() {
  return (
    <PageLayout>
      <PageLayout.Section>
        <IceCaActionsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
